import { render, staticRenderFns } from "./Administrator.vue?vue&type=template&id=5a822804&scoped=true"
import script from "./Administrator.vue?vue&type=script&lang=js"
export * from "./Administrator.vue?vue&type=script&lang=js"
import style0 from "./Administrator.vue?vue&type=style&index=0&id=5a822804&prod&scoped=true&lang=less"
import style1 from "./Administrator.vue?vue&type=style&index=1&id=5a822804&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a822804",
  null
  
)

export default component.exports